// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4525":"6d2ac961","9089":"a4f3a220"}[chunkId] + ".chunk.css";
};